import classes from "./CategoriesInFocus.module.css";
import { useCategoriesInFocus } from "../../Pregrine/CategoriesInFocus/useCategoriesInFocus";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import classNames from "classnames";

const CategoriesInFocus = () => {
  const { categoriesInFocusData } = useCategoriesInFocus();

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="pt-3 pb-2 CategoriesInFocus">
      <div className="container">
        <div className="row">
          <h2 className={`${classes.title} text-center pb-2`}>
            Categories In Focus
          </h2>
        </div>
        {categoriesInFocusData && categoriesInFocusData.length > 0 ? (
          <Slider {...settings}>
            {categoriesInFocusData.map((item, idx) => (
              <div className={classes.category} key={idx}>
                <div className={classes.item}>
                  <div className="col-lg-5 col-12">
                    <div className={classNames(classes.item1, classes.mr3)}>
                      <img
                        src={item.image}
                        alt={item.name}
                        width={540}
                        height={400}
                        loading={idx === 0 ? "eager" : "lazy"}
                      />
                      <div className={classes["cat-text"]}>
                        <h5>{item.name}</h5>
                        <Link
                          to={`/category/${item.url_path}`}
                          className={classes.viewAll}
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className={`col-lg-7 col-12 ${classes["category-sub"]}`}>
                    <div className="row">
                      {item.subcategories.items.length >= 1
                        ? item.subcategories.items
                            .slice(0, 5)
                            .map((child, index) => (
                              <SubCategory
                                name={child?.name}
                                image={child?.image}
                                link={child?.url_path}
                                key={index}
                                isCategory={true}
                                parentIdx={idx}
                              />
                            ))
                        : item.products.items &&
                          item.products.items
                            .slice(0, 5)
                            .map((subchild, subIdx) => (
                              <SubCategory
                                name={subchild.name}
                                image={subchild?.image.url}
                                link={subchild?.url_key}
                                key={subIdx}
                                isCategory={false}
                                parentIdx={idx}
                              />
                            ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className={classes.category}>
            <div className={classes.item}>
              <div className="col-lg-5 col-12">
                <div className={classNames(classes.item1, classes.mr3)}>
                  <div className="placeholder-glow">
                    <span
                      className={`${classes.BannerPlaceholder} placeholder`}
                    />
                  </div>
                </div>
              </div>
              <div className={`col-lg-7 col-12 ${classes["category-sub"]}`}>
                <div className="row">
                  {Array(4)
                    .fill("")
                    .map((_, idx) => (
                      <div className="col-lg-6 col-6" key={idx}>
                        <div className="placeholder-glow">
                          <span
                            className={`${classes.BannerPlaceholder} placeholder`}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

const SubCategory = ({ name, image, link, isCategory, parentIdx }) => {
  return (
    <div className="col-lg-6 col-6">
      <Link
        to={isCategory ? `/category/${link}` : `/product/${link}.html`}
        className={classes.cardLink}
      >
        <div className={classes.item1}>
          <img
            src={image}
            alt={name}
            width={366}
            height={200}
            loading={parentIdx === 0 ? "eager" : "lazy"}
          />
          <div className={classes.subitem}>
            <h5>{name}</h5>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CategoriesInFocus;
